import { IMAGE_BASE_URL } from "@/services";

export const payxpress_laptop = `${IMAGE_BASE_URL}payxpress_laptop.svg`;
export const easy_image = `${IMAGE_BASE_URL}easyImage.png`;
export const fast_image = `${IMAGE_BASE_URL}fastImage.png`;
export const secure_image = `${IMAGE_BASE_URL}secureImage.png`;
export const desktop_image = `${IMAGE_BASE_URL}desktopView.svg`;
export const mobile_image = `${IMAGE_BASE_URL}mobileView.svg`;
export const carousel_one = `${IMAGE_BASE_URL}carousel_one.svg`;
export const payxpress_logo = `${IMAGE_BASE_URL}payxpress_logo.svg`;
export const payxpress_png_logo = `${IMAGE_BASE_URL}payxpress.png`;
export const fadeLogo = `${IMAGE_BASE_URL}fadedxpresspay.png`;
export const cbn_logo = `${IMAGE_BASE_URL}cbn_logo.png`;
export const Pos_logo = `${IMAGE_BASE_URL}pos_logo.svg`;
export const Biller_logo = `${IMAGE_BASE_URL}biller_service_logo.svg`;
export const Payout = `${IMAGE_BASE_URL}payout_logo.svg`;
export const Payment_gateway_logo = `${IMAGE_BASE_URL}payment_gateway_logo.svg`;
export const NgnFlag = `${IMAGE_BASE_URL}NgnFlag.svg`;
export const Orange_arrow = `${IMAGE_BASE_URL}orange_arrow.svg`;
export const Green_arrow = `${IMAGE_BASE_URL}green_arrow.svg`;
export const Black_arrow = `${IMAGE_BASE_URL}black_arrow.svg`;
export const Double_quote = `${IMAGE_BASE_URL}double_quote.svg`;
export const Keystone_logo = `${IMAGE_BASE_URL}keystone_logo.svg`;
export const Shago_logo = `${IMAGE_BASE_URL}shago_logo.svg`;
export const Oyo_logo = `${IMAGE_BASE_URL}oyo_logo.svg`;
export const Delta_logo = `${IMAGE_BASE_URL}delta_logo.svg`;
export const profile_image = `${IMAGE_BASE_URL}olubunmi_img.svg`;
export const fast = `${IMAGE_BASE_URL}fast.svg`;
export const secure = `${IMAGE_BASE_URL}secure.svg`;
export const auth_image_bubble = `${IMAGE_BASE_URL}auth_image_bubble.svg`;
export const auth_image_one = `${IMAGE_BASE_URL}auth_image_one.svg`;
export const auth_star = `${IMAGE_BASE_URL}auth_star.svg`;
export const promo_image = `${IMAGE_BASE_URL}promo.png`;
export const cashback = `${IMAGE_BASE_URL}cashback.png`;
export const Cabletv_icon = `${IMAGE_BASE_URL}cabletv_icon.svg`;
export const Electricity_icon = `${IMAGE_BASE_URL}electricity_icon.svg`;
export const Insurance_icon = `${IMAGE_BASE_URL}insurance_icon.svg`;
export const Airtime_icon = `${IMAGE_BASE_URL}airtime_icon.svg`;
export const Data_icon = `${IMAGE_BASE_URL}data_icon.svg`;
export const Education_icon = `${IMAGE_BASE_URL}education_icon.svg`;
export const Pension_icon = `${IMAGE_BASE_URL}pension.svg`;
export const Ticket_icon = `${IMAGE_BASE_URL}ticket_icon.svg`;
export const betting_icon = `${IMAGE_BASE_URL}betting_icon.svg`;
export const Government_icon = `${IMAGE_BASE_URL}government_icon.svg`;
export const txn = `${IMAGE_BASE_URL}icons/txn.svg`;
export const docs = `${IMAGE_BASE_URL}icons/doc.svg`;
export const HomeIcon = `${IMAGE_BASE_URL}icons/home`;
export const mobile = `${IMAGE_BASE_URL}icons/mobile.svg`;
export const wallet = `${IMAGE_BASE_URL}icons/empty-wallet.svg`;
export const active_home = `${IMAGE_BASE_URL}icons/active_mobile_home.svg`;
export const active_history = `${IMAGE_BASE_URL}icons/active_mobile_history.svg`;
export const active_payment = `${IMAGE_BASE_URL}icons/active_mobile_payment.svg`;
export const inactive_home = `${IMAGE_BASE_URL}icons/inactive_mobile_home.svg`;
export const inactive_payment = `${IMAGE_BASE_URL}icons/inactive_mobile_payment.svg`;
export const inactive_history = `${IMAGE_BASE_URL}icons/inactive_mobile_history.svg`;
export const inactive_wallet = `${IMAGE_BASE_URL}icons/inactive_mobile_wallet.svg`;
export const inactive_profile = `${IMAGE_BASE_URL}icons/inactive_mobile_profile.svg`;
export const arrowRight = `${IMAGE_BASE_URL}icons/Vector-3.svg`;
export const close_button = `${IMAGE_BASE_URL}icons/close_button.svg`;
export const recurring_icon = `${IMAGE_BASE_URL}icons/repeat-circle.svg`;
export const yellow_dollar = `${IMAGE_BASE_URL}yellow_dollar.svg`;
export const green_dollar = `${IMAGE_BASE_URL}green_dollar.svg`;
export const green_person = `${IMAGE_BASE_URL}green_person.svg`;
export const red_person = `${IMAGE_BASE_URL}red_person.svg`;
export const large_brick = `${IMAGE_BASE_URL}large_brick.svg`;
export const small_brick = `${IMAGE_BASE_URL}small_brick.svg`;
export const bill_action = `${IMAGE_BASE_URL}bill_action.svg`;
export const confetti = `${IMAGE_BASE_URL}confetti.png`;
export const more = `${IMAGE_BASE_URL}icons/more.svg`;
export const referral = `${IMAGE_BASE_URL}refer.png`;
export const visa = `${IMAGE_BASE_URL}Visa_logo.png`;
export const FaqsBG = `${IMAGE_BASE_URL}faqBg.svg`;
export { default as ProfileIcon } from "./icons/ProfileIcon";
export { default as SettingsIcon } from "./icons/SettingsIcon";
export { default as LogoutIcon } from "./icons/Logout";
export { default as ArrowDownIcon } from "./icons/ArrowDownIcon";
export { default as CheckmarkIcon } from "./icons/checkmark";
export { default as WarningIcon } from "./icons/warning";
export { default as ClockIcon } from "./icons/clock";
export { default as CloseIcon } from "./icons/closeIcon";
export { default as CopyIcon } from "./icons/copy";
export const Faq1 = `${IMAGE_BASE_URL}icons/FAQ1.svg`;
export const Faq2 = `${IMAGE_BASE_URL}icons/FAQ2.svg`;
export const Faq3 = `${IMAGE_BASE_URL}icons/FAQ3.svg`;
export const Faq4 = `${IMAGE_BASE_URL}icons/FAQ4.svg`;
export const Faq5 = `${IMAGE_BASE_URL}icons/FAQ5.svg`;
export const Faq6 = `${IMAGE_BASE_URL}icons/FAQ6.svg`;
export const QuestionChat = `${IMAGE_BASE_URL}icons/QuestionChat.svg`;
